import { Injectable, Injector } from '@angular/core';
import {
  DocumentCategory,
  DocumentCategoryDetail,
  DocumentCategoryFilterParams,
  DocumentCategoryParams
} from '../../core/declarations/document-category.interface';

import {
  DefineRepositoryParams,
  RepositoryAbstract
} from './repository.abstract';

export type DocumentCategoryRepositoryParams = DefineRepositoryParams<
  DocumentCategoryDetail,
  {
    all: DocumentCategory[];
    queryParams: DocumentCategoryFilterParams;
    createParams: DocumentCategoryParams;
  }
>;

@Injectable({
  providedIn: 'root'
})
export class DocumentCategoryRepository extends RepositoryAbstract<DocumentCategoryRepositoryParams> {
  constructor(injector: Injector) {
    super('document_categories', injector);
  }
}
